import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ChangePassword } from "../model/ChangePassword";
import { CommonServiceBase } from "../../Shared/service/CommonService";
import { ClientSideUtility } from "../../Shared/service/ClientSideUtility";
import { AuthenticationBase } from "../../Shared/service/Authentication";
import { ConfigurationReaderBase } from "../../Shared/service/ConfigurationReader";

@Component({
    templateUrl: "../view/UserProfile.html"  
  })

export class UserProfileComponent implements OnInit{

  changePassword: ChangePassword;
  passwordRules: Array<string>

  constructor(private commonService: CommonServiceBase, private clientSideUtility: ClientSideUtility, 
              private configurationReader: ConfigurationReaderBase){
    this.changePassword = new ChangePassword();
    this.passwordRules = new Array<string>();
  }

  ngOnInit(){    
    this.getPasswordRules();
  }
  
  submit(form: NgForm){

    if(!form.valid){
      return;
    }

    this.clientSideUtility.startSpinner();
    this.commonService.changePassword(this.changePassword).subscribe(r=>{

      this.clientSideUtility.stopSpinner();
      if(r.message != null && r.message.length > 0){

        let errorsList: string = "";
        r.message.forEach(function (value) {
          errorsList += value + '<br/>'
        });

        this.clientSideUtility.showAlertError("Change Password", errorsList);
      }
      else
      {
          form.resetForm();            
          this.clientSideUtility.showAlertSuccess("Change Password", "Password have changed successfully");
      }
    },
    (error:any)=> {
        this.clientSideUtility.stopSpinner();
        this.clientSideUtility.showAlertError("Change Password", "Error: " + error);
    });
  }

  getPasswordRules(){
    this.clientSideUtility.startSpinner();
    this.commonService.getPasswordRules().subscribe(r=>{
      this.passwordRules = r;
      this.clientSideUtility.stopSpinner();      
    },
    (error:any)=> {
        this.clientSideUtility.stopSpinner();
        this.clientSideUtility.showAlertError("Password Rules", "Error: " + error);
    });
  }

}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Home/component/UserProfile.ts